module.exports = __webpack_public_path__ + "static/roll-off-dumpsters-banner-0aedbd807e76a2fcd57931b3fb115576.jpg";